import { render, staticRenderFns } from "./AuthorInfo.vue?vue&type=template&id=edf47f1e&scoped=true&"
import script from "./AuthorInfo.vue?vue&type=script&lang=ts&"
export * from "./AuthorInfo.vue?vue&type=script&lang=ts&"
import style0 from "./AuthorInfo.vue?vue&type=style&index=0&id=edf47f1e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf47f1e",
  null
  
)

export default component.exports